/* DD No-Salt page motion. One small script for the three visual sections.
   - [data-ddns-reveal]  gets .is-in once, when it scrolls into view (CSS does the move)
   - [data-ddns-scrub]   gets --p (0 to 1) as it travels up the screen (the glass fills)
   - [data-ddns-count]   counts up to data-to when its [data-ddns-reveal] ancestor gets .is-in
   Reduced motion, the theme editor and browsers without IntersectionObserver get the finished state.
   Per-element idempotent, re-wired on shopify:section:load. Adds .ddns-js to <html> so the pre-move
   state only exists when this script is running (no script = finished state, nothing hidden). */
(function () {
  var root = document.documentElement;
  root.classList.add('ddns-js');
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESIGN = !!(window.Shopify && Shopify.designMode);
  var STILL = RM || DESIGN || !('IntersectionObserver' in window);
  var scrubbed = [];
  var ticking = false;

  function count(el) {
    var to = parseInt(el.getAttribute('data-to'), 10);
    if (isNaN(to)) return;
    if (STILL) { el.textContent = to; return; }
    var t0 = null, dur = 900;
    el.textContent = 0;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var io = STILL ? null : new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      e.target.querySelectorAll('[data-ddns-count]').forEach(count);
      io.unobserve(e.target);
    });
  }, { threshold: 0.3 });

  function update() {
    ticking = false;
    var vh = window.innerHeight || 800;
    scrubbed.forEach(function (el) {
      if (!el.isConnected) return;
      var r = el.getBoundingClientRect();
      // 0 when the top edge is at 92% of the screen, 1 when it reaches 38%.
      var p = (vh * 0.92 - r.top) / (vh * 0.54);
      p = Math.max(0, Math.min(1, p));
      el.style.setProperty('--p', p.toFixed(3));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ddns-reveal]').forEach(function (el) {
      if (el.dataset.ddnsWired) return;
      el.dataset.ddnsWired = '1';
      if (STILL) { el.classList.add('is-in'); el.querySelectorAll('[data-ddns-count]').forEach(count); return; }
      io.observe(el);
    });
    (scope || document).querySelectorAll('[data-ddns-scrub]').forEach(function (el) {
      if (el.dataset.ddnsWired) return;
      el.dataset.ddnsWired = '1';
      if (STILL) { el.style.setProperty('--p', '1'); return; }
      scrubbed.push(el);
    });
    if (scrubbed.length) update();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
